export const styles = {
  container: {
    marginTop: '20px',
    display: 'flex',
    width: '100%',
    gap: '8px',
    alignItems: 'end',
  },
  paper: {
    padding: '4px 1px',
    '& ul': {
      overflowY: 'auto',
    },
  },
  menuItem: {
    padding: '14px 16px',
    borderRadius: '9px',
    '&:hover': {
      backgroundColor: '#F2F5FF',
    },
  },
};
